/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BuildingBlockFeedbackRequest,
  BuildingBlockFeedbackResponse,
  BuildingBlockRequest,
  BuildingBlockResponse,
  FeedbackNote,
} from '../models/index';
import {
    BuildingBlockFeedbackRequestFromJSON,
    BuildingBlockFeedbackRequestToJSON,
    BuildingBlockFeedbackResponseFromJSON,
    BuildingBlockFeedbackResponseToJSON,
    BuildingBlockRequestFromJSON,
    BuildingBlockRequestToJSON,
    BuildingBlockResponseFromJSON,
    BuildingBlockResponseToJSON,
    FeedbackNoteFromJSON,
    FeedbackNoteToJSON,
} from '../models/index';

export interface BuildingBlockCompletedRequest {
    buildingBlockRequest?: BuildingBlockRequest;
}

export interface BuildingBlockFavoriteRequest {
    buildingBlockRequest?: BuildingBlockRequest;
}

export interface BuildingBlockStatusRequest {
    buildingBlockRequest?: BuildingBlockRequest;
}

export interface BuildingBlockUndoCompletedRequest {
    buildingBlockRequest?: BuildingBlockRequest;
}

export interface SetFeedbackRequest {
    buildingBlockFeedbackRequest?: BuildingBlockFeedbackRequest;
}

/**
 * 
 */
export class BuildingBlockApi extends runtime.BaseAPI {

    /**
     */
    async buildingBlockCompletedRaw(requestParameters: BuildingBlockCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuildingBlockResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/BuildingBlockApi/BuildingBlockCompleted`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BuildingBlockRequestToJSON(requestParameters.buildingBlockRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BuildingBlockResponseFromJSON(jsonValue));
    }

    /**
     */
    async buildingBlockCompleted(requestParameters: BuildingBlockCompletedRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuildingBlockResponse> {
        const response = await this.buildingBlockCompletedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async buildingBlockFavoriteRaw(requestParameters: BuildingBlockFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuildingBlockResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/BuildingBlockApi/BuildingBlockFavorite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BuildingBlockRequestToJSON(requestParameters.buildingBlockRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BuildingBlockResponseFromJSON(jsonValue));
    }

    /**
     */
    async buildingBlockFavorite(requestParameters: BuildingBlockFavoriteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuildingBlockResponse> {
        const response = await this.buildingBlockFavoriteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async buildingBlockStatusRaw(requestParameters: BuildingBlockStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuildingBlockResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/BuildingBlockApi/BuildingBlockStatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BuildingBlockRequestToJSON(requestParameters.buildingBlockRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BuildingBlockResponseFromJSON(jsonValue));
    }

    /**
     */
    async buildingBlockStatus(requestParameters: BuildingBlockStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuildingBlockResponse> {
        const response = await this.buildingBlockStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async buildingBlockUndoCompletedRaw(requestParameters: BuildingBlockUndoCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuildingBlockResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/BuildingBlockApi/BuildingBlockUndoCompleted`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BuildingBlockRequestToJSON(requestParameters.buildingBlockRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BuildingBlockResponseFromJSON(jsonValue));
    }

    /**
     */
    async buildingBlockUndoCompleted(requestParameters: BuildingBlockUndoCompletedRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuildingBlockResponse> {
        const response = await this.buildingBlockUndoCompletedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFeedbackNotesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FeedbackNote>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/BuildingBlockApi/GetFeedbackNotes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeedbackNoteFromJSON));
    }

    /**
     */
    async getFeedbackNotes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FeedbackNote>> {
        const response = await this.getFeedbackNotesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async setFeedbackRaw(requestParameters: SetFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BuildingBlockFeedbackResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/BuildingBlockApi/SetFeedback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BuildingBlockFeedbackRequestToJSON(requestParameters.buildingBlockFeedbackRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BuildingBlockFeedbackResponseFromJSON(jsonValue));
    }

    /**
     */
    async setFeedback(requestParameters: SetFeedbackRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BuildingBlockFeedbackResponse> {
        const response = await this.setFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
